// PRC data client. Routes through the Athena API gateway (platform-api) exactly like
// the mdm/ram features, so the Keycloak bearer added by the global axios interceptor
// (src/index.js) is attached automatically. Always calls the real backend — there is no
// mock-data fallback here.
// eslint-disable-next-line @typescript-eslint/no-var-requires
const serverConfig = require("../../../config/server.js");
import axios from "axios";

const BASE: string = serverConfig.api_base_url;

// All PRC endpoints live under this gateway slug (proxied to the PRC microservice).
export const PRC_PREFIX = "portfolio-risk-concentrations/";

function url(path: string): string {
  if (path.startsWith("http")) return path;
  return `${BASE}${path.replace(/^\//, "")}`;
}

export async function getJson<T>(path: string): Promise<T> {
  const res = await axios.get<T>(url(path));
  return res.data;
}

export async function postJson<T>(path: string, body?: unknown): Promise<T> {
  const res = await axios.post<T>(url(path), body ?? {});
  return res.data;
}

/** POSTs a JSON body and returns the response as a Blob with its headers, for a download whose request is too big for a query string. */
export async function postBlob(path: string, body?: unknown): Promise<{ blob: Blob; contentDisposition: string | undefined }> {
  const res = await axios.post<Blob>(url(path), body ?? {}, { responseType: "blob" });
  return { blob: res.data, contentDisposition: res.headers?.["content-disposition"] };
}

/** GETs a file as a Blob with its headers, for a download whose request fits a query string. */
export async function getBlob(
  path: string,
  params?: Record<string, string>,
): Promise<{ blob: Blob; contentDisposition: string | undefined }> {
  const res = await axios.get<Blob>(url(path), { params, responseType: "blob" });
  return { blob: res.data, contentDisposition: res.headers?.["content-disposition"] };
}

export async function putJson<T>(path: string, body?: unknown): Promise<T> {
  const res = await axios.put<T>(url(path), body ?? {});
  return res.data;
}

export async function patchJson<T>(path: string, body?: unknown): Promise<T> {
  const res = await axios.patch<T>(url(path), body ?? {});
  return res.data;
}

export async function deleteJson<T>(path: string): Promise<T> {
  const res = await axios.delete<T>(url(path));
  return res.data;
}
